// extracted by mini-css-extract-plugin
module.exports = {"login-page":"styles_login-page__2N2_e"};